// extracted by mini-css-extract-plugin
module.exports = {"searchInputContainer":"searchinput_searchInputContainer__25u5k","searchIconContainer":"searchinput_searchIconContainer__2nJ5S"};